import type { z } from 'zod';
import type { PrizeCategorySchema } from '~shared/schemas';
import techImg from '~/assets/prize-types/tech.png';
import bonusImg from '~/assets/prize-types/bonus.png';
import merchImg from '~/assets/prize-types/merch.png';
import bizImg from '~/assets/prize-types/biz.png';
import promoImg from '~/assets/prize-types/promo.png';

export type PrizeCategory = z.infer<typeof PrizeCategorySchema>;

/**
 * Картинка типа приза по категории (connect-landing-draw, design, решение 6): макет заказчика «Категории призов»,
 * только картинки категорий призов, не продуктов промокодов. Общая для лендинга и админки.
 * `Record` по enum категорий: новая категория без картинки не пройдёт `pnpm typecheck`.
 */
export const PRIZE_TYPE_IMAGE: Record<PrizeCategory, string> = {
  TECH: techImg,
  BONUS: bonusImg,
  PRODUCT: merchImg,
  BUSINESS: bizImg,
  PROMO: promoImg,
};
